import styled from 'styled-components'

import {
  Info,
  Skeleton,
  TypeStyleBodyMicro,
  TypeStyleBodyNano,
  TypeStyleHeadlineExtraSmall,
  TypeStyleHeadlineMicro,
  fromMd,
  timingDefault,
  untilMd,
} from '@syconium/little-miss-figgy'

import { PromoText } from '../styles'

export const PortalPromoText = styled(PromoText)`
  /* Apply mobile padding on mobile for promo text used in tab content */
  ${untilMd} {
    padding-left: 16px;
    padding-right: 16px;
  }
`
export const Pill = styled.div`
  height: ${o => o.theme.spacing(8)};
  width: fit-content;
  border-radius: ${o => o.theme.spacing(5)};
  background-color: ${o => o.theme.color.deprecated.stoneLighter};
  &:hover {
    background-color: ${o => o.theme.color.deprecated.stoneLight};
  }
  transition: background-color ${timingDefault};
`

export const PillSkeleton = styled(Skeleton)`
  margin-top: ${o => o.theme.spacing(6)};
  ${untilMd} {
    margin-left: ${o => o.theme.spacing(4)};
  }
`

export const Caption = styled(TypeStyleHeadlineMicro)`
  color: ${o => o.theme.color.text.primary.on.background};
`

export const RulerSvg = (
  <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
    <path
      d='M4.78005 10.5892L3.42476 11.9445C3.03423 12.335 3.03423 12.9682 3.42476 13.3587L6.72459 16.6585C7.11511 17.0491 7.74828 17.0491 8.1388 16.6585L16.7419 8.05542C17.1325 7.66489 17.1325 7.03173 16.7419 6.6412L13.4421 3.34137C13.0516 2.95085 12.4184 2.95085 12.0279 3.34137L10.6726 4.69666M4.78005 10.5892L6.25319 12.0624M4.78005 10.5892L6.84244 8.52682M6.84244 8.52682L8.90484 10.5892M6.84244 8.52682L8.61021 6.75905M8.61021 6.75905L10.0833 8.23219M8.61021 6.75905L10.6726 4.69666M10.6726 4.69666L12.735 6.75905'
      stroke='#282828'
      strokeWidth='1.5'
    />
  </svg>
)

export const SizeChartSvg = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <rect x='5.83301' y='4.16663' width='11.6667' height='1.66667' rx='0.833333' fill='#282828' />
      <rect x='2.5' y='4.16663' width='1.66667' height='1.66667' rx='0.833333' fill='#282828' />
      <rect x='5.83301' y='9.16663' width='11.6667' height='1.66667' rx='0.833333' fill='#282828' />
      <rect x='2.5' y='9.16663' width='1.66667' height='1.66667' rx='0.833333' fill='#282828' />
      <rect x='5.83301' y='14.1666' width='11.6667' height='1.66667' rx='0.833333' fill='#282828' />
      <rect x='2.5' y='14.1666' width='1.66667' height='1.66667' rx='0.833333' fill='#282828' />
    </svg>
  )
}

export const PillContent = styled.div`
  display: flex;
  padding: ${o => o.theme.spacing(1.5)} ${o => o.theme.spacing(2.5)};
  justify-contents: center;
  align-items: center;
  min-width: ${o => o.theme.spacing(24)};
  gap: ${o => o.theme.spacing(1)};
`
export const SizeModalLink = styled.button`
  margin-top: ${o => o.theme.spacing(6)};
  display: block;
  width: min-content;
  ${untilMd} {
    margin-left: ${o => o.theme.spacing(4)};
  }
`

export const RecommendedFitWrapper = styled.div`
  margin-top: ${o => o.theme.spacing(6)};
  ${untilMd} {
    margin-left: ${o => o.theme.spacing(4)};
    margin-right: ${o => o.theme.spacing(4)};
  }
`

export const EditFitLink = styled(TypeStyleBodyMicro)`
  font-weight: 500;
  text-decoration: underline;
`

export const BoldCondensedSizeRecCategoryLabel = styled(TypeStyleHeadlineMicro)`
  font-weight: 700;
  padding-bottom: ${o => o.theme.spacing(2)};
  color: ${o => o.theme.color.text.primary.on.background};
`

export const StyledInfo = styled(Info)`
  stroke: none;
  > path {
    fill: ${o => o.theme.color.stroke.neutral.border.interaction.primary.on.background};
  }
  > circle {
    stroke: ${o => o.theme.color.stroke.neutral.border.interaction.primary.on.background};
  }
  padding-left: ${o => o.theme.spacing(1)};
`
export const TooltipSpacer = styled.div`
  width: 100%;
  height: ${o => o.theme.spacing(1)};
  ${fromMd} {
    width: 100%;
    height: ${o => o.theme.spacing(2)};
  }
`

export const TooltipHeadline = styled(TypeStyleHeadlineExtraSmall)`
  ${fromMd} {
    font-size: 12px;
  }
`

export const TooltipBody = styled(TypeStyleBodyNano)`
  font-weight: 400;
  font-size: 12px;
  ${fromMd} {
    font-weight: 500;
  }
`
